import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    is_loaded: false,

    events: {
        'click .user-id-lookup' : 'openUserIdentification',
        'click .user-delete'    : 'deleteUser',
        'click .attr-search'    : 'attrSearch'
    },

    dom_handlers: {
        openUserIdentification: function(e) {
            e.preventDefault();
            Modals.openUserIdentification(this.model.get('identification'));
        },

        deleteUser: function() {
            Modals.deleteUserIdentification(this.model);
        },

        attrSearch: function(e) {
            e.preventDefault();

            Cache.app.dispatcher.trigger('User_Data::search', {
                key: $(e.currentTarget).data('val'),
                val: $(e.currentTarget).text()
            });
        }
    },

    event_handlers: {
        onUserRemove: function(model) {
            if (this.model && this.model.get('identification') === model.get('identification')) {
                this.model = null;
                this.renderEmpty();
            }
        }
    },

    initialize: function(options) {
        this.identification = options.identification || null;
        this.sidebar = !!options.sidebar; // in feedback sidebar?

        if (this.identification) {
            this.model = Cache.user_identification.findWhere({identification: this.identification});
            this.listenTo(this.model, 'change', this.renderAttributes);
        }

        this.listenTo(Cache.user_identification, 'remove', this.event_handlers.onUserRemove);
    },

    load: function() {
        Cache.app.request({
            action: 'user_identification/search',
            data: {
                identification: [this.identification],
                include_properties: true
            },
            success: (response) => {
                this.is_loaded = true;

                Cache.user_identification.add(response.data);

                this.model = Cache.user_identification.findWhere({identification: this.identification});

                if (this.model) {
                    this.listenTo(this.model, 'change', this.renderAttributes);
                    this.renderAttributes();
                } else {
                    this.renderEmpty();
                }
            }
        });
    },

    renderAttributes: function() {
        if (!this.model) {
            return;
        }

        var content =
            '<div class="title">User:</div>' +
            '<div class="value">' +
                '<a class="user-id-lookup" href="#">' + Util.htmlEntities(this.model.get('identification')) + '</a>' +
                (this.model.get('display_name') ?
                '<div class="ellipsis info text-small">' + Util.htmlEntities(this.model.get('display_name')) + '</div>' : '') +
                (this.model.get('email') ?
                '<div class="ellipsis info text-small">' + Util.htmlEntities(this.model.get('email')) + '</div>' : '') +
                (this.model.get('last_location') ?
                '<div class="ellipsis info text-small"><i class="fas fa-map-marker-alt"></i> ' + Util.htmlEntities(this.model.get('last_location')) + '</div>' : '') +
            '</div>' +
            '<div class="title">First seen:</div>' +
            '<div class="value">' + Util.moment(this.model.get('first_seen')) + '</div>' +
            '<div class="title">Last seen:</div>' +
            '<div class="value">' + Util.moment(this.model.get('last_seen')) + '</div>';

        _.each(this.model.get('props'), (user_value, user_key) => {
            content +=
                '<div class="title">' + Util.htmlEntities(user_key) + '</div>' +
                '<div class="value">' + Util.htmlEntities(user_value) + '</div>';
        });

        this.getRegionElement().html(content);
        this.$el.find('.item-count').show();
    },

    setId: function(identification) {
        this.identification = identification;
    },

    getRegionElement: function() {
        return this.sidebar ? this.$el.find('.item-content > div') : this.$el;
    },

    renderEmpty: function() {
        var empty_text = 'No identified user data captured. You will need to call identify() in your app to identify users. <a target="help" rel="noopener" href="https://docs.userback.io/docs/user-identification">Find out more</a>.';
        this.getRegionElement().addClass('empty').html(empty_text);
    },

    render: function() {
        var content = '';

        if (this.sidebar) {
            content +=
            '<div class="item-header item-header-collapsible">' +
                '<span>User Data</span>' +
                '<span class="item-count text-icon" style="display:none;"><i class="fa-solid fa-badge-check"></i></span>' +
            '</div>' +
            '<div class="item-content box-neutral-light"><div></div></div>';
        }

        this.$el.html(content);

        if (this.identification) {
            if (this.model) {
                this.renderAttributes();
            } else {
                this.load();
            }
        } else {
            this.renderEmpty();
        }

        return this;
    }
});